import React from 'react'
import { PropTypes } from 'prop-types'
import { Dialog } from '@mui/material'

import useStyles from 'shared/hooks/useStyle'

import QRScannerView from './QRScannerView'
import styles from './QRCodeScanner.style'

const propTypes = {
    onScan: PropTypes.func,
    onCancel: PropTypes.func,
    isBarCodeScan: PropTypes.bool,
    scanMode: PropTypes.bool,
}

const QRCodeScanner = ({
    onScan,
    onCancel,
    isBarCodeScan = false,
    scanMode = false,
}) => {
    const classes = useStyles(styles)

    return (
        <Dialog
            fullScreen
            open={scanMode}
        >
            { scanMode && (
                <div css={classes.root}>
                    <QRScannerView
                        onScan={onScan}
                        onCancel={onCancel}
                        isBarCodeScan={isBarCodeScan}
                    />
                </div>
            )}
        </Dialog>
    )
}

QRCodeScanner.propTypes = propTypes

export default QRCodeScanner
